/**
 * The opponent identity names as etchable glyph outlines — one filled <path> per
 * letter, so the in-play name strips (and the game-start "Lothar" wordmark) can be
 * built and ETCHED through `buildGlyphWordSvg` (DOM text can't be DrawSVG-etched).
 * The two AI opponents are the fixed pair Lothar (left) and Stef (right) —
 * `SkatSession.java` is the source of truth, IDENTITY § The three identity layers —
 * so two pre-extracted wordmarks cover every name shown on the board; the
 * player-entered human name is never etched (it isn't shown in-play).
 *
 * "Lothar" is the AI's namesake, so it is both the game-start logo and the left
 * opponent's name — one outline, one source. The author-generated data below is
 * regenerated, never hand-edited; regen command in the generated header.
 */
// IDENTITY_NAME_GLYPHS — generated by scripts/extract-glyphs.py. DO NOT hand-edit.
// Satoshi-Bold (700) glyph outlines, one <path> per letter, laid out with the
// logo's 0.04em tracking, y-flipped into SVG space (baseline at y=0). Coordinates
// are in font units (unitsPerEm=1000). Source font: Satoshi-Bold.woff2.
// Regenerate: scripts/doc-tools/extract-glyphs.py --name IDENTITY_NAME_GLYPHS Lothar Stef | npx prettier --parser babel

export const IDENTITY_NAME_GLYPHS = {
  Lothar: {
    viewBox: "-40 -1010 3284 1250",
    glyphs: [
      { ch: "L", d: "M209 -731V-118H515V0H81V-731Z" },
      {
        ch: "o",
        d: "M686.5 -60.5Q612.0 -133 612.0 -248.0Q612.0 -363 686.5 -435.5Q761.0 -508 876.0 -508.0Q991.0 -508 1065.5 -435.5Q1140.0 -363 1140.0 -248.0Q1140.0 -133 1065.5 -60.5Q991.0 12 876.0 12.0Q761.0 12 686.5 -60.5ZM773.5 -357.0Q734.0 -315 734.0 -248.0Q734.0 -181 773.5 -139.0Q813.0 -97 876.0 -97.0Q939.0 -97 978.5 -139.0Q1018.0 -181 1018.0 -248.0Q1018.0 -315 978.5 -357.0Q939.0 -399 876.0 -399.0Q813.0 -399 773.5 -357.0Z",
      },
      {
        ch: "t",
        d: "M1445.0 0H1323.0V-392H1228.0V-494H1323.0V-648H1445.0V-494H1541.0V-392H1445.0Z",
      },
      {
        ch: "h",
        d: "M1779.0 0H1657.0V-744H1780.0V-430Q1804.0 -467 1846.0 -488.0Q1888.0 -509 1940.0 -509Q2030.0 -509 2078.0 -455.0Q2126.0 -401 2126.0 -304V0H2004.0V-275Q2004.0 -336 1976.5 -367.0Q1949.0 -398 1901.0 -398Q1844.0 -398 1811.5 -362.5Q1779.0 -327 1779.0 -270Z",
      },
      {
        ch: "a",
        d: "M2433.0 13Q2355.0 13 2309.5 -29.0Q2264.0 -71 2264.0 -141Q2264.0 -209 2311.5 -250.0Q2359.0 -291 2447.0 -298L2595.0 -309V-320Q2595.0 -414 2493.0 -414Q2439.0 -414 2410.0 -392.5Q2381.0 -371 2381.0 -332H2277.0Q2277.0 -412 2337.5 -460.5Q2398.0 -509 2499.0 -509.0Q2600.0 -509 2657.0 -455.0Q2714.0 -401 2714.0 -300V0H2607.0L2598.0 -73Q2582.0 -35 2536.5 -11.0Q2491.0 13 2433.0 13ZM2473.0 -79Q2530.0 -79 2563.0 -111.0Q2596.0 -143 2596.0 -200V-226L2493.0 -218Q2388.0 -208 2388.0 -146Q2388.0 -79 2473.0 -79Z",
      },
      {
        ch: "r",
        d: "M3184.0 -496V-383H3139.0Q3071.0 -383 3033.5 -347.0Q2996.0 -311 2996.0 -240V0H2874.0V-493H2989.0L2996.0 -421Q3012.0 -459 3047.0 -481.0Q3082.0 -503 3130.0 -503Q3156.0 -503 3184.0 -496Z",
      },
    ],
  },
  Stef: {
    viewBox: "-40 -1010 2028 1250",
    glyphs: [
      {
        ch: "S",
        d: "M39 -527Q39 -623 111.5 -683.5Q184 -744 299 -744Q410 -744 476.0 -686.5Q542 -629 545 -530H417Q415 -577 383.0 -603.5Q351 -630 297 -630Q238 -630 202.5 -603.5Q167 -577 167 -531Q167 -456 256 -436L371 -411Q557 -371 557 -211Q557 -109 484.0 -48.0Q411 13 290 13Q173 13 102.0 -45.0Q31 -103 29 -201H157Q158 -155 193.0 -128.5Q228 -102 290 -102Q354 -102 391.5 -128.0Q429 -154 429 -200Q429 -273 344 -291L228 -317Q39 -358 39 -527Z",
      },
      {
        ch: "t",
        d: "M863.0 0H741.0V-392H646.0V-494H741.0V-648H863.0V-494H959.0V-392H863.0Z",
      },
      {
        ch: "e",
        d: "M1296.0 13Q1186.0 13 1116.0 -59.5Q1046.0 -132 1046.0 -247Q1046.0 -363 1114.5 -436.0Q1183.0 -509 1292.0 -509Q1403.0 -509 1468.5 -440.5Q1534.0 -372 1534.0 -256V-219L1162.0 -218Q1176.0 -87 1298.0 -87Q1401.0 -87 1423.0 -160H1536.0Q1520.0 -79 1456.5 -33.0Q1393.0 13 1296.0 13ZM1293.0 -409Q1183.0 -409 1165.0 -296H1413.0Q1413.0 -347 1380.5 -378.0Q1348.0 -409 1293.0 -409Z",
      },
      {
        ch: "f",
        d: "M1623.0 -494H1694.0V-554Q1694.0 -651 1741.0 -697.5Q1788.0 -744 1872.0 -744Q1909.0 -744 1935.0 -739V-635H1892.0Q1848.0 -635 1831.5 -614.5Q1815.0 -594 1815.0 -554V-494H1933.0V-392H1815.0V0H1694.0V-392H1623.0Z",
      },
    ],
  },
};
